import { applyAkamaiIM } from '@dh-io-owpi/shared/src/utils/getAkamaiIM';
import type { PictureProps } from '@dh-io-owpi/shared/src/components/ResponsiveImg';
import type { AemFeatureElement } from '../lib/types/aem';
import type { SimpleListItemModel, SimpleListProps } from '../components/SimpleList/SimpleList.types';
import type { Feature } from '../lib/api/api';

/* istanbul ignore file for now */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useVehicleFeaturesWithSimpleList(featureElements?: AemFeatureElement[]) {
  function buildSimpleListProps(features: Feature[]): SimpleListProps {
    return {
      items: features.map<SimpleListItemModel>((feature: Feature) => {
        let aemFeatureElement: AemFeatureElement | undefined;

        if (featureElements) {
          aemFeatureElement = featureElements.find(
            (featureElement: AemFeatureElement) => featureElement.code === feature.equipmentId,
          );
        }

        return {
          id: feature.equipmentId,
          image: {
            picture: feature.imageUrl ? mapToPictureProps(feature.imageUrl) : undefined,
            title: feature.title,
            description: feature.description,
          },
          headline: feature.title,
          description: feature.description,
          buttonData: {
            label: aemFeatureElement?.ctaButtonText || '',
          },
        };
      }),
    };
  }

  return {
    buildSimpleListProps,
  };
}

const IM_WIDTH = 1200;
const IM_HEIGHT = 900;
export function mapToPictureProps(imageUrl: string): PictureProps {
  return {
    sources: [
      {
        srcset: applyAkamaiIM(imageUrl, [['Resize', (118 * IM_WIDTH) / IM_HEIGHT]]),
        media: '(max-width: 767px)',
      },
      {
        srcset: applyAkamaiIM(imageUrl, [['Resize', (90 * IM_WIDTH) / IM_HEIGHT]]),
        media: '(max-width: 1279px)',
      },
    ],
    img: {
      src: applyAkamaiIM(imageUrl, [['Resize', (156 * IM_WIDTH) / IM_HEIGHT]]),
    },
  };
}
